"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayAction = void 0;
const refreshReserves_1 = require("./util/refreshReserves");
const models_1 = require("../../models");
const larixInstructionCollector_1 = require("../../utils/larixInstructionCollector");
const baseAction_1 = require("./util/baseAction");
const account_1 = require("../../utils/account");
class RepayAction extends baseAction_1.BaseAction {
    /**
     *
     * @param amount U64_MAX will repay all
     * @param repayReserve
     * @param larixObligation
     */
    repay(amount, repayReserve, larixObligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingProgramID = this.marketConfig.programId;
            const repayReserveDetail = repayReserve.state;
            const liquidityTokenAccount = this.userInfo.getLiquidityTokenAccount(repayReserve);
            if (liquidityTokenAccount === undefined) {
                throw new Error("Invalid liquidity token account");
            }
            let obligation = larixObligation === null || larixObligation === void 0 ? void 0 : larixObligation.state;
            if (obligation === undefined) {
                const myObligations = yield this.userInfo.getObligationOfMarket(repayReserveDetail.info.lendingMarket, lendingProgramID);
                if (myObligations.length > 0) {
                    obligation = myObligations[0];
                }
            }
            if (obligation == undefined) {
                throw new Error("Invalid obligation");
            }
            const larixTransaction = new larixInstructionCollector_1.LarixInstructionCollector(this.wallet);
            const sourceLiquidity = (0, account_1.ensureSplAccount)(larixTransaction.instructions, larixTransaction.cleanupInstructions, liquidityTokenAccount, this.userInfo.publicKey, liquidityTokenAccount.info.amount.toNumber() - 10000, larixTransaction.signers);
            yield (0, refreshReserves_1.refreshReserves)(this.connection, this.marketConfig, larixTransaction.instructions, [repayReserveDetail], lendingProgramID);
            larixTransaction.instructions.push((0, models_1.repayObligationLiquidityInstruction)(amount, sourceLiquidity, repayReserveDetail.info.liquidity.supplyPubkey, repayReserveDetail.pubkey, obligation.pubkey, repayReserveDetail.info.lendingMarket, lendingProgramID, this.userInfo.publicKey));
            return larixTransaction;
        });
    }
}
exports.RepayAction = RepayAction;
